import produce from 'immer';
import { registerReducer } from '../../../StateSetup/RootReducer';

export const ACTION_NAME = 'action/resetBank';

export const ResetBank = () => ({
    type: ACTION_NAME,
});

export const reducer = produce((state) => {
    state.BankData.isBankValid = false;
    if (state.MemberData.member.bankAccount) {
        state.BankData.bankName = state.MemberData.member.bankAccount.bankName;
    }
});

registerReducer(ACTION_NAME, reducer);
